import React, { useState, useEffect, useRef, useMemo } from "react";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { timeValues } from "../../../constants/constants";
import cx from "../clients.module.css";
import {
  formatDate,
  getCurrentTimeZone,
  toTitleCase,
} from "../../../utils/CommonFunctions";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { currentCareSiteId } from "../../../redux-toolkit/reducer/switchSites";
import { riskProfileColorCodes } from "./constants";
import { httpAdmin } from "../../../Apis/commonApis";
import { useLocation } from "react-router-dom";
import { ShowSwal } from "../../../utils/alertSwal";
import { fetchClientCarePlans } from "../../../redux-toolkit/reducer/clientCarePlanReducer";

function CareplanModal({
  open,
  handleCloseCarePlanModal,
  openModalDetails,
  CareplanAccess,
}) {
  const location = useLocation();
  const clientId = location.state?.clientId;

  const dispatch = useDispatch();

  const { currentPlanName } = useSelector((state) => state.caresiteDataReducer);
  const isPlanBase = currentPlanName === "Base";

  const [taskList, setTaskList] = useState({});

  const [loading, setLoading] = useState(false);

  const initialCarePlanFormVals = {
    TemplateName: "",
    risk_profile: "",
    riskProfileCategory: "",
    updated_by: "",
    questions: [],
    obeservation_needs_comments: "",
    outcomes: "",
    wishes: "",
    strength: "",
    Safeguarding: [],
    risk_interventions: [],
    Task: [],
    timeZone: getCurrentTimeZone(),
  };

  const [carePlanFormVals, setCarePlanFormVals] = useState(
    initialCarePlanFormVals
  );

  useEffect(() => {
    getTaskList();
  }, []);

  useEffect(() => {
    // console.log(openModalDetails, "openModalDetails");
    if (openModalDetails?.isEdit) {
      const { _id, ...restData } = openModalDetails.editData;
      setCarePlanFormVals((prev) => ({
        ...prev,
        ...restData,
      }));
    }
    if (openModalDetails?.qnaData) {
      const qnaString = openModalDetails?.qnaData.join("\n");
      handleValueChangeByName("obeservation_needs_comments", qnaString);
    }
  }, [openModalDetails]);
  // ---------------- Create Care plan Templates based on currentCareSiteId -------------------//

  const createOrUpdateCarePlan = async (saveType) => {
    let user_data = JSON.parse(localStorage.getItem("userData"));
    if (carePlanFormVals.TemplateName?.trim() === "") {
      return;
    }
    const planType =
      saveType === "saveToPlan" ? "careplan" : openModalDetails?.planType;
    setLoading(true);
    const addRiskProfileInTask = carePlanFormVals.Task.map((item) => {
      return {
        ...item,
        riskProfileCategory:
          carePlanFormVals?.risk_profile ??
          carePlanFormVals.riskProfileCategory,
      };
    });
    const finalValues = {
      ...carePlanFormVals,
      Task: addRiskProfileInTask,
      careHomeId: currentCareSiteId,
      docType: planType, // template || careplan
      categoryType: carePlanFormVals.riskProfileCategory,
      carePlanCategoryId: openModalDetails?.catId,
      updated_by: `${user_data.firstName?.trim()} ${user_data?.lastName}`,
      last_update_date: new Date(),
    };
    if (planType === "careplan") {
      finalValues.clientId = clientId;
    }
    handleCloseModal();

    let endPoint = "createClientCarePlan";
    if (openModalDetails.isEdit && saveType !== "saveToPlan") {
      endPoint = `createClientCarePlan?id=${openModalDetails?.editData?._id}`;
    }
    const res = await httpAdmin(endPoint, "post", finalValues, null);
    ShowSwal(res.status, res.message ?? "");
    if (res.status) {
      const qString = `?clientId=${clientId}&careHomeId=${currentCareSiteId}`;
      dispatch(fetchClientCarePlans(qString));
    }
    setLoading(false);
  };

  const deleteCarePlan = async () => {
    handleCloseModal();
    const cPlanId = openModalDetails?.editData?._id;
    const res = await httpAdmin(
      `deleteClientCarePlan?id=${cPlanId}`,
      "post",
      {},
      null
    );
    ShowSwal(res.status, res.message ?? "");
    if (res.status) {
      const qString = `?clientId=${clientId}&careHomeId=${currentCareSiteId}`;
      dispatch(fetchClientCarePlans(qString));
    }
  };

  const getTaskList = async () => {
    const res = await httpAdmin("getTask", "get", null, null);
    if (res.taskData) {
      setTaskList(res?.taskData ?? {});
    }
  };

  const handleCarePlanInputChange = (event) => {
    const { name, value } = event.target;
    setCarePlanFormVals((prev) => ({ ...prev, [name]: value }));
  };

  const handleValueChangeByName = (fName, fVal) => {
    handleCarePlanInputChange({ target: { name: fName, value: fVal } });
  };

  const [taskObj, setTaskObj] = useState({
    taskName: "",
    desc: "",
    startTime: "No",
    endTime: "No",
  });
  const [riskObj, setRiskObj] = useState({
    risk: "",
    interventions: "",
  });
  const initialSafeguarding = {
    safeguardingConcern: "",
    crimeRefNumber: "",
    gpInformed: "",
    safeguardingStartDate: "",
    safeguardingEndDate: "",
    policeAware: "",
  };
  const [safeGuardObj, setSafeGuardObj] = useState(initialSafeguarding);

  //  -------- tsk handlers -----------

  const handleTaskObjChange = (event) => {
    const { name, value } = event.target;
    setTaskObj((prev) => ({ ...prev, [name]: value }));
  };

  const handleTaskAdd = () => {
    if (taskObj.taskName === "") {
      return;
    }
    let userData = JSON.parse(localStorage.getItem("userData"));
    let newObj = {
      shiftType: "within time",
      startTime: taskObj.startTime,
      endTime: taskObj.endTime,
      taskName: openModalDetails.catName,
      riskProfileCategory: carePlanFormVals.riskProfileCategory,
      taskType: taskObj.taskName,
      status: "false",
      comments: taskObj.desc,
      createdBy: userData.userType,
      uid: Date.now(),
    };
    if (taskObj.startTime !== "No") {
      newObj.shiftType = "specific time";
      // let calculatedEndTime = addMinutesToTime(taskObj.spTime, 30);
      // newObj.startTime = taskObj.spTime;
      // newObj.endTime = calculatedEndTime;
    }
    let newArr = [...carePlanFormVals.Task, newObj];
    handleValueChangeByName("Task", newArr);
    setTaskObj({ taskName: "", desc: "", startTime: "No", endTime: "No" });
  };

  const addedTaskRemoveHandler = async (e, tItem, tIndex) => {
    e.preventDefault();
    if (tItem?._id) {
      const clonefield = carePlanFormVals.Task.filter(
        (item) => item._id !== tItem._id
      );
      handleValueChangeByName("Task", clonefield);
      const endpoint = `deleteClientCarePlanTask?id=${tItem?._id}`;
      const res = await httpAdmin(endpoint, "post", {}, null);
      if (res.status) {
        // const filteredTasks = carePlanFormVals.Task.filter(
        //   (item) => item._id !== tItem._id
        // );
        // handleValueChangeByName("Task", filteredTasks);
      }
    } else {
      const clonefield = carePlanFormVals.Task.filter(
        (item) => item.uid !== tItem.uid
      );
      handleValueChangeByName("Task", clonefield);
    }
  };

  //  -------- risk handlers ----------

  const handleRiskObjChange = (event) => {
    const { name, value } = event.target;
    setRiskObj((prev) => ({ ...prev, [name]: value }));
  };

  const handleRiskAdd = () => {
    if (riskObj.risk === "") {
      return;
    }
    let newArr = [...carePlanFormVals.risk_interventions, riskObj];
    handleValueChangeByName("risk_interventions", newArr);
    setRiskObj({ risk: "", interventions: "" });
  };

  const addedRiskRemoveHandler = (e, indexToRemove) => {
    e.preventDefault();
    const clonefield = carePlanFormVals?.risk_interventions.slice();
    clonefield.splice(indexToRemove, 1);
    handleValueChangeByName("risk_interventions", clonefield);
  };

  //  -------- risk handlers ----------

  const handleSafegaurdObjChange = (event) => {
    const { name, value } = event.target;
    setSafeGuardObj((prev) => ({ ...prev, [name]: value }));
  };

  const handleSafeguardingAdd = () => {
    let newArr = [...carePlanFormVals.Safeguarding, safeGuardObj];
    handleValueChangeByName("Safeguarding", newArr);
    setSafeGuardObj(initialSafeguarding);
  };

  const addedSafegaurdRemoveHandler = (e, indexToRemove) => {
    e.preventDefault();
    const clonefield = carePlanFormVals?.Safeguarding.slice();
    clonefield.splice(indexToRemove, 1);
    handleValueChangeByName("Safeguarding", clonefield);
  };

  const handleCloseModal = () => {
    setCarePlanFormVals(initialCarePlanFormVals);
    handleCloseCarePlanModal();
  };

  return (
    <Modal
      className="viewModal"
      show={open}
      size="lg"
      onHide={() => handleCloseModal()}
    >
      <div className="predefineTemplate">
        <h3>
          Care Plan{" "}
          {openModalDetails?.planType === "template" ? "Template" : ""}
        </h3>
        {/* {isPlanBase && (
          <p className="mb-0">
            Only Template Name and Task Addition is allowed in Base Plan
          </p>
        )} */}
        <div className="row mt-4 mb-5 align-items-center">
          <div className="col-md-6">
            <input
              placeholder={`Care Plan Template Name`}
              type="text"
              className="form-control"
              name="TemplateName"
              value={carePlanFormVals?.TemplateName}
              onChange={handleCarePlanInputChange}
            />
          </div>
          <div className="col-md-6">
            <ul className="menuListTop">
              <li>
                <button
                  className="btn"
                  onClick={createOrUpdateCarePlan}
                  disabled={CareplanAccess !== "full"}
                >
                  {openModalDetails?.isEdit ? "Update" : "Save"}
                </button>
                {openModalDetails?.isEdit &&
                  openModalDetails?.planType === "template" && (
                    <button
                      className="btn"
                      disabled={CareplanAccess !== "full"}
                      onClick={() => createOrUpdateCarePlan("saveToPlan")}
                    >
                      Save to plan
                    </button>
                  )}
                {openModalDetails?.isEdit && (
                  <button
                    className="btn"
                    onClick={() => deleteCarePlan()}
                    disabled={CareplanAccess !== "full"}
                  >
                    Delete
                  </button>
                )}
              </li>
              <li>
                <button className="btn" onClick={handleCloseModal}>
                  Close
                </button>
              </li>
            </ul>
          </div>
        </div>

        <Modal.Body>
          <div className="row">
            <div className="col-md-12 mb-3">
              <ul className="catList">
                <h6 className="mb-0">Select Risk Profile: </h6>
                {Object.keys(riskProfileColorCodes).map((elem) => {
                  return (
                    <li
                      key={elem}
                      className={
                        carePlanFormVals?.risk_profile === elem ? elem : ""
                      }
                      style={{
                        backgroundColor: riskProfileColorCodes[elem],
                      }}
                      onClick={(e) => {
                        // if (!isPlanBase) {
                          handleValueChangeByName("risk_profile", elem);
                          handleValueChangeByName("riskProfileCategory", elem);
                        // }
                      }}
                    >
                      {toTitleCase(elem)} <br /> Risk
                    </li>
                  );
                })}
              </ul>
              <h6>
                Last Update Date:{" "}
                {openModalDetails?.editData
                  ? formatDate(openModalDetails?.editData?.updatedAt)
                  : ""}
              </h6>
              <h6>
                Updated By:{" "}
                {openModalDetails?.editData
                  ? openModalDetails?.editData?.updated_by
                  : ""}
              </h6>
            </div>
            {/* Questions and Answers Dynamic Form  */}

            <>
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-12">
                    <h5>Observations, Needs and Comments</h5>
                    <div className="d-flex mb-3">
                      <textarea
                        style={{ minHeight: "150px" }}
                        className="form-control"
                        placeholder=""
                        // disabled={isPlanBase}
                        name="obeservation_needs_comments"
                        value={carePlanFormVals?.obeservation_needs_comments}
                        onChange={handleCarePlanInputChange}
                      ></textarea>
                    </div>

                    <h5>Outcomes</h5>
                    <div className="d-flex mb-3">
                      <textarea
                        style={{ minHeight: "150px" }}
                        className="form-control"
                        placeholder=""
                        // disabled={isPlanBase}
                        name="outcomes"
                        value={carePlanFormVals?.outcomes}
                        onChange={handleCarePlanInputChange}
                      ></textarea>
                    </div>

                    <h5>Strength</h5>
                    <div className="d-flex mb-3">
                      <textarea
                        style={{ minHeight: "150px" }}
                        className="form-control"
                        placeholder=""
                        // disabled={isPlanBase}
                        name="strength"
                        value={carePlanFormVals?.strength}
                        onChange={handleCarePlanInputChange}
                      ></textarea>
                    </div>

                    <h5>Wishes</h5>
                    <div className="d-flex mb-3">
                      <textarea
                        style={{ minHeight: "150px" }}
                        className="form-control"
                        placeholder=""
                        // disabled={isPlanBase}
                        name="wishes"
                        value={carePlanFormVals?.wishes}
                        onChange={handleCarePlanInputChange}
                      ></textarea>
                    </div>
                  </div>

                  <div className="col-md-12 mb-2">
                    <div className="d-flex">
                      <div
                        className={`col-md-3 position-relative ${cx.reactAutocomplete}`}
                      >
                        <label className="mb-1">Task</label>
                        <Autocomplete
                          disablePortal
                          id="combo-box-demo"
                          value={taskObj.taskName}
                          ListboxProps={{
                            style: {
                              maxHeight: 80,
                              backgroundColor: "#d9e5f2",
                            },
                          }}
                          onChange={(event, newVal) =>
                            setTaskObj((prev) => ({
                              ...prev,
                              taskName: newVal ?? prev.taskName,
                            }))
                          }
                          inputValue={taskObj?.taskName}
                          onInputChange={(event, newInputValue) => {
                            setTaskObj((prev) => ({
                              ...prev,
                              taskName: newInputValue,
                            }));
                          }}
                          options={
                            taskList?.[openModalDetails?.catApiKey || ""] ?? []
                          }
                          renderInput={(params) => (
                            <TextField {...params} label="" />
                          )}
                        />
                      </div>
                      <div className="col-md-4 ms-3">
                        <label>Description</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Add description"
                          name="desc"
                          value={taskObj.desc}
                          onChange={handleTaskObjChange}
                        />
                      </div>
                      <div className="col-md-2 ms-3">
                        <label>Start Time</label>
                        <select
                          className="form-select"
                          name="startTime"
                          value={taskObj.startTime}
                          onChange={handleTaskObjChange}
                        >
                          <option value="No">No</option>
                          {timeValues.map((item) => {
                            return (
                              <option key={item.value} value={item.value}>
                                {item.label}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="col-3 ms-3">
                        <label> End Time</label>
                        <div className="d-flex">
                          <div className="col-7">
                            <select
                              className="form-select"
                              name="endTime"
                              disabled={taskObj.startTime === "No"}
                              value={taskObj.endTime}
                              onChange={handleTaskObjChange}
                            >
                              <option value="No">No</option>
                              {timeValues
                                .filter((item) => {
                                  return item.value > taskObj.startTime;
                                })
                                .map((item) => {
                                  return (
                                    <option key={item.value} value={item.value}>
                                      {item.label}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>
                          <button
                            className={cx.removeBtn}
                            onClick={handleTaskAdd}
                          >
                            ADD
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {carePlanFormVals.Task?.map((tItem, index) => {
                    return (
                      <div key={index} className="col-md-12 mb-2">
                        <div className="d-flex">
                          <div className="col-3">
                            <input
                              className="form-control"
                              type="text"
                              value={tItem?.taskType}
                              disabled
                            />
                          </div>
                          <div className="col-4 ms-3">
                            <input
                              className="form-control"
                              type="text"
                              value={tItem?.comments}
                              disabled
                            />
                          </div>
                          <div className="col-2 ms-3">
                            <input
                              className="form-control"
                              type="text"
                              value={tItem?.startTime}
                              disabled
                            />
                          </div>
                          <div className="col-3 ms-3">
                            <div className="d-flex">
                              <div className="col-7">
                                <input
                                  className="form-control"
                                  type="text"
                                  value={tItem.endTime}
                                  disabled
                                />
                              </div>
                              <button
                                className={cx.removeBtn}
                                onClick={(e) => {
                                  addedTaskRemoveHandler(e, tItem);
                                }}
                              >
                                -
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                  <div className="col-md-12 mb-2">
                    <div className="d-flex">
                      <div
                        className={`col-6 position-relative ${cx.reactAutocomplete}`}
                      >
                        <label className="mb-1">Risks</label>
                        <input
                          type="text"
                          className="form-control mb-3"
                          placeholder="Add Risk"
                          // disabled={isPlanBase}
                          name="risk"
                          value={riskObj.risk}
                          onChange={handleRiskObjChange}
                        />
                      </div>
                      <div className="col-6" style={{ marginLeft: "33px" }}>
                        <label>Interventions</label>
                        <div style={{ display: "flex" }}>
                          <div className="col-md-10">
                            <input
                              type="text"
                              className="form-control mb-3"
                              placeholder=""
                              // disabled={isPlanBase}
                              name="interventions"
                              value={riskObj.interventions}
                              onChange={handleRiskObjChange}
                            />
                          </div>
                          <button
                            className={cx.removeBtn}
                            onClick={handleRiskAdd}
                          >
                            ADD
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {carePlanFormVals.risk_interventions?.map((item, index) => {
                    return (
                      <div key={index} className="col-md-12 mb-2">
                        <div className="d-flex">
                          <div className="col-6">
                            <input
                              className="form-control"
                              type="text"
                              value={item?.risk}
                              disabled
                            />
                          </div>
                          <div className="col-6" style={{ marginLeft: "33px" }}>
                            <div style={{ display: "flex" }}>
                              <div className="col-10">
                                <input
                                  className="form-control"
                                  type="text"
                                  value={item.interventions}
                                  disabled
                                />
                              </div>
                              <button
                                className={cx.removeBtn}
                                onClick={(e) => {
                                  addedRiskRemoveHandler(e, index);
                                }}
                              >
                                -
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}

                  <div className="col-md-12 my-3 d-flex">
                    <div className="d-flex">
                      <div className={`${cx.safeBox} d-flex col-md-11`}>
                        <div
                          className={`col-md-4 position-relative ${cx.reactAutocomplete}`}
                        >
                          <label className="mb-1">Safeguarding Concern</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Safeguarding Concern"
                            name="safeguardingConcern"
                            value={safeGuardObj?.safeguardingConcern}
                            onChange={handleSafegaurdObjChange}
                          />
                        </div>
                        <div className="col-4 ms-3">
                          <label>Crime reference number</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Crime reference number"
                            name="crimeRefNumber"
                            value={safeGuardObj?.crimeRefNumber}
                            onChange={handleSafegaurdObjChange}
                          />
                        </div>

                        <div className="col-4 ms-3">
                          <label>GP informed</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="GP informed"
                            name="gpInformed"
                            value={safeGuardObj?.gpInformed}
                            onChange={handleSafegaurdObjChange}
                          />
                        </div>
                        <div className="col-3 ms-3">
                          <label>Police aware</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Have the police been made aware if applicable"
                            name="policeAware"
                            value={safeGuardObj?.policeAware}
                            onChange={handleSafegaurdObjChange}
                          />
                        </div>

                        <div className="col-5 ms-3">
                          <label>Safeguarding concerns start date</label>
                          <input
                            type="date"
                            className="form-control"
                            name="safeguardingStartDate"
                            value={safeGuardObj?.safeguardingStartDate}
                            onChange={handleSafegaurdObjChange}
                          />
                        </div>
                        <div className="col-5 ms-3">
                          <label>Safeguarding concerns end date</label>
                          <input
                            type="date"
                            className="form-control"
                            name="safeguardingEndDate"
                            value={safeGuardObj?.safeguardingEndDate}
                            onChange={handleSafegaurdObjChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-1">
                        <button
                          className={cx.removeBtn}
                          onClick={handleSafeguardingAdd}
                        >
                          ADD
                        </button>
                      </div>
                    </div>
                  </div>
                  {carePlanFormVals.Safeguarding?.map((item, i) => {
                    return (
                      <div className="col-md-12 mb-3 d-flex" key={i}>
                        <div className="d-flex">
                          <div className={`${cx.safeBox} d-flex col-md-11`}>
                            <div
                              className={`col-md-4 position-relative ${cx.reactAutocomplete}`}
                            >
                              <label className="mb-1">
                                Safeguarding Concern
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                disabled
                                placeholder="Safeguarding Concern"
                                value={item?.safeguardingConcern}
                              />
                            </div>
                            <div className="col-4 ms-3">
                              <label>Crime reference number</label>
                              <input
                                type="text"
                                className="form-control"
                                disabled
                                placeholder="Crime reference number"
                                value={item?.crimeRefNumber}
                              />
                            </div>

                            <div className="col-4 ms-3">
                              <label>GP informed</label>
                              <input
                                type="text"
                                className="form-control"
                                disabled
                                placeholder="GP informed"
                                value={item?.gpInformed}
                              />
                            </div>
                            <div className="col-3 ms-3">
                              <label>Police aware</label>
                              <input
                                type="text"
                                className="form-control"
                                disabled
                                placeholder="Have the police been made aware if applicable"
                                value={item?.policeAware}
                              />
                            </div>

                            <div className="col-5 ms-3">
                              <label>Safeguarding concerns start date</label>
                              <input
                                type="date"
                                className="form-control"
                                disabled
                                value={formatDate(item?.safeguardingStartDate)}
                              />
                            </div>
                            <div className="col-5 ms-3">
                              <label>Safeguarding concerns end date</label>
                              <input
                                type="date"
                                className="form-control"
                                disabled
                                value={formatDate(item?.safeguardingEndDate)}
                              />
                            </div>
                          </div>
                          <div className="col-md-1">
                            <button
                              className={cx.removeBtn}
                              onClick={(e) => {
                                addedSafegaurdRemoveHandler(e, i);
                              }}
                            >
                              -
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </>
          </div>
        </Modal.Body>
      </div>
    </Modal>
  );
}

export default CareplanModal;
